import React, { useState } from "react";
import { Button, Input, List } from "antd";
import { useTranslation } from "react-i18next";
import { matchesSearchQuery } from "../../utils/searchMatcher";

export default function LayoutFilter({ drivers, onSelectDriver, compact = false }) {
  const [query, setQuery] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const { t } = useTranslation();

  const filteredDrivers = drivers.filter((driver) =>
    matchesSearchQuery([driver.name, driver.headId, ...(driver.tags || [])], query)
  );

  const handleSelect = (driver) => {
    setQuery(driver.name || driver.headId);
    setShowSuggestions(false);
    if (onSelectDriver) onSelectDriver(driver);
  };

  const handleChange = (e) => {
    setQuery(e.target.value);
    setShowSuggestions(true);
  };

  const handleClear = () => {
    setQuery("");
    setShowSuggestions(false);
    if (onSelectDriver) onSelectDriver(null);
  };

  return (
    <div style={{ width: compact ? 240 : 300, padding: compact ? 0 : 8 }}>
      <div style={{ display: "flex", gap: 8 }}>
        <Input
          size={compact ? "small" : "middle"}
          placeholder={t("fleetLayout.searchDriver")}
          value={query}
          onChange={handleChange}
        />
        {query && (
          <Button size="small" onClick={handleClear}>
            {t("driverFilter.button")}
          </Button>
        )}
      </div>

      {showSuggestions && query && filteredDrivers.length > 0 && (
        <List
          bordered
          style={{ marginTop: compact ? 6 : 8, maxHeight: 200, overflowY: "auto" }}
          dataSource={filteredDrivers}
          renderItem={(driver, idx) => (
            <List.Item onClick={() => handleSelect(driver)} style={{ cursor: "pointer" }}>
              {driver.name || "Sin nombre"} - {driver.headId || "Sin matrícula"}
            </List.Item>
          )}
        />
      )}
    </div>
  );
}
